import React, { useEffect, useState } from 'react';
import { useApi } from 'src/hooks/useApi';
import LoadingSpinner from 'src/components/LoadingSpinner';
import { useNavigate } from 'react-router';
import { ArtifactDetailModal } from 'src/components/ArtifactDetail/components/ArtifactDetailModal';
import './artifact-detail-overrides.scss';
import { GetArtifactDetailApiType } from 'src/types/useApi';
import { useRenderContent } from 'src/components/ArtifactDetail/components/useRenderContent';

type ArtifactDetailProps = {
    artifactId: string;
    contentObjectLcmsXmlGUID: string;
};

const ArtifactDetail = ({
    artifactId,
    contentObjectLcmsXmlGUID,
}: ArtifactDetailProps) => {
    const navigate = useNavigate();
    const [modalHref, setModalHref] = useState<string>('');

    const {
        makeRequest: getDocumentHTML,
        data,
        error,
        loading,
    }: GetArtifactDetailApiType = useApi({
        method: 'GET',
    });

    useEffect(() => {
        if (error) {
            navigate('/error', {
                state: { ticketUrl: (error as any)?.ticketUrl },
            });
        }
    }, [error]);

    useEffect(() => {
        if (artifactId && contentObjectLcmsXmlGUID) {
            getDocumentHTML({
                url: `/learning-artifacts/v2/document/${artifactId}/${contentObjectLcmsXmlGUID}`,
            });
        }
    }, [artifactId, contentObjectLcmsXmlGUID]);

    const { artifactHtml } = useRenderContent({
        data,
        artifactId,
        setModalHref,
        loading,
    });
    return loading || artifactId === '' ? (
        <LoadingSpinner />
    ) : (
        <>
            {modalHref && (
                <ArtifactDetailModal
                    modalHref={modalHref}
                    setModalHref={setModalHref}
                    artifactId={artifactId}
                />
            )}
            <object className={'xyleme-container'}>{artifactHtml}</object>
        </>
    );
};

export default ArtifactDetail;
